import { DocumentosResposta } from '../interfaces/form-flow';

export const getTituloDocumentoResposta = (
  document: Pick<DocumentosResposta, 'assunto' | 'conteudo' | 'titulo_exibicao'>,
): string => {
  if (document.titulo_exibicao) {
    return document.titulo_exibicao;
  }
  if (document.conteudo) {
    const match = document.conteudo.match(
      /Arquivo enviado pelo cidadão:\s*([^<\n]+)/i,
    );
    if (match?.[1]) {
      return match[1].trim();
    }
  }
  return document.assunto || 'Documento';
};

export const getNomeDownloadDocumentoResposta = (
  document: Pick<DocumentosResposta, 'assunto' | 'conteudo' | 'titulo_exibicao'>,
): string | undefined => {
  const titulo = getTituloDocumentoResposta(document);
  if (!titulo) {
    return undefined;
  }
  return titulo.toLowerCase().endsWith('.pdf') ? titulo : `${titulo}.pdf`;
};
